<div class="el-breadcrumb-wrapper">
    <div class="container">
        <div class="el-breadcrmb-inner">
            <h1>Progress Report</h1>
            <ul>

                <li> <a [routerLink]="['/report']" style="color: #e04787;"><i class="fa fa-reply "
                            aria-hidden="true"></i> Back</a></li>
            </ul>
        </div>
    </div>
</div>

<div class="el-pricing-wrapper ">
    <div class="container">
        <div class="el-pricing-main-parent" *ngIf="ReportData!=null">

            <div class="woo-cart-table text-start" #content id="content">
                <div class="row">
                    <div>
                        <h3 class="">{{ReportData.resultDetails.ChildName}}</h3>
                    </div>
                    <hr>
                    <div class="col-md-12 d-flex justify-content-between">
                        <div>


                            Subject: <strong>{{ReportData.resultDetails.SubjectName}}</strong><br>

                            Exam Date: <strong>
                                {{ReportData.resultDetails.StartExam|date:'dd-MMM-yyyy hh:mm:ss a'}}</strong><br>

                        </div>
                        <div>
                            Class: <strong>{{ReportData.resultDetails.ClassName}}</strong><br>

                            Mock: <strong>{{ReportData.resultDetails.MockSet}}</strong>

                        </div>


                    </div>
                    <div class="col-md-12 ">
                        <hr>
                        <!-- <div class="col-md-6 col-12  signin_el_btn el-btn s my-2">
                            Total Number of Students:&nbsp;
                            <strong>{{ReportData.resultDetails.Total_Student}}</strong><br>
                        </div>
                        <div class="col-md-6 col-12  signin_el_btn el-btn  my-2">
                            Total Number of Students Who have secured Less than Marks:&nbsp;
                            <strong>{{ReportData.resultDetails.Total_Number_Less_than_Marks}}</strong><br>
                        </div> -->

                    </div>
                </div>
                <!-- *ngIf="ReportData.resultDetails.MockSet.startsWith('Pre')" -->
                <div class="row mb-4 justify-content-center">
                    <div class="row gy-4">

                        <div class="col-lg-4 col-md-6">
                            <div class="el-work-box el-work-box-2">
                                <div class="el-work-box-inner">
                                    <div class="el-work-step">
                                        <h4>My Percentage</h4>
                                    </div>
                                    <div class="d-flex justify-content-between align-items-center">
                                        <div class="el-work-content">
                                            <!-- <h4> My Percentage:</h4> -->

                                        </div>
                                        <div class="el-work-img">

                                            <i class="fas fa fa-3x ">{{ReportData.resultDetails.Marks|
                                                number:'1.2-2'
                                                }}%</i>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-4 col-md-6">
                            <div class="el-work-box el-work-box-3">
                                <div class="el-work-box-inner">
                                    <div class="el-work-step">
                                        <h4>Percentile</h4>
                                    </div>
                                    <div class="el-work-img">
                                        <i class="fas fa fa-3x ">{{(ReportData.resultDetails.Total_Number_Less_than_Marks/ReportData.resultDetails.Total_Student)*100|
                                            number:'1.2-2'}}%</i>

                                    </div>
                                    <div class="el-work-content">

                                        <!-- <p class="el-para">
                                            <strong>{{(ReportData.resultDetails.Total_Number_Less_than_Marks/ReportData.resultDetails.Total_Student)*100|
                                                number:'1.2-2'}}</strong>
                                        </p> -->
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-6">
                            <div class="el-work-box el-work-box-4">
                                <div class="el-work-box-inner">
                                    <div class="el-work-step">
                                        <h4>Rank</h4>
                                    </div>
                                    <div class="el-work-img">

                                        <i class="fa-solid fa fa-3x ">{{ReportData.resultDetails.Rank}}</i>&nbsp;&nbsp;
                                        <i class="fas fa-award fa-3x "></i>


                                    </div>
                                    <div class="el-work-content">

                                        <!-- <p class="el-para">
                                            {{ReportData.resultDetails.Rank}}
                                        </p> -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row my-2 text-dark"><b>Percentiles and ranks are calculated dynamically, they may change
                            over time
                            depending on participant activity.</b></div>
                </div>

                <div class="row">
                    <div class="container">
                        <!-- <strong>(A).</strong> My Percentage: <strong>{{ReportData.resultDetails.Marks| number:'1.2-2'
                            }}%</strong><br>
                        <strong>(B).</strong> Total Number of Students Who have secured Less than <strong>(A)</strong>:
                        <strong>{{ReportData.resultDetails.Total_Number_Less_than_Marks}}</strong><br>
                        <strong>(C).</strong> Total Number of Students:
                        <strong>{{ReportData.resultDetails.Total_Student}}</strong><br>
                        <strong>(D).</strong> Percentile:
                        <strong>{{(ReportData.resultDetails.Total_Number_Less_than_Marks/ReportData.resultDetails.Total_Student)*100|
                            number:'1.2-2'}}</strong><br>
                        <strong>(E).</strong> Rank:
                        <strong>{{ReportData.resultDetails.Rank}}</strong>
                        <br><br> -->
                        <div class="accordion" id="accordionPanelsStayOpenExample">
                            <div class="accordion-item">
                                <h2 class="accordion-header" id="panelsStayOpen-headingOne">
                                    <button class="accordion-button" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#panelsStayOpen-collapseOne" aria-expanded="true"
                                        aria-controls="panelsStayOpen-collapseOne">
                                        <h5>Unit Wise Analysis</h5>
                                        <small>This report shows how you did in each unit, so you can see your strengths
                                            and where
                                            you
                                            can improve.</small>
                                    </button>
                                </h2>
                                <div id="panelsStayOpen-collapseOne" class="accordion-collapse collapse show"
                                    aria-labelledby="panelsStayOpen-headingOne">
                                    <div class="accordion-body">
                                        <div class="row">
                                            <div class="col-md-7">
                                                <div class="table-responsive">
                                                    <table class="table table-bordered">
                                                        <thead>
                                                            <tr>
                                                                <th>S.No.</th>
                                                                <th>Unit</th>
                                                                <th>Marks</th>
                                                                <th>Total Question</th>
                                                                <th>Correct Answer</th>
                                                                <th>Obtained Marks</th>

                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr
                                                                *ngFor="let _obj of ReportData.unitSummary; let i = index">
                                                                <td>{{ i + 1 }}</td>
                                                                <td>
                                                                    {{_obj.UnitNo}}: {{ _obj.UnitName }}
                                                                </td>

                                                                <td>{{ _obj.Marks }}</td>
                                                                <td>{{ _obj.NOQ }}</td>
                                                                <td>{{ _obj.Total_CorrectAns }}</td>
                                                                <td>{{ _obj.ObtainedMarks }}</td>
                                                            </tr>
                                                        </tbody>
                                                        <tfoot>
                                                            <th colspan="2" style="text-align: end;">Total</th>
                                                            <th>{{ReportData.unitSummary| sum:'Marks' }}</th>
                                                            <th>{{ReportData.unitSummary| sum:'NOQ' }}</th>
                                                            <th>{{ReportData.unitSummary| sum:'Total_CorrectAns' }}</th>
                                                            <th>{{ReportData.unitSummary| sum:'ObtainedMarks' }}</th>
                                                        </tfoot>

                                                    </table>
                                                </div>
                                            </div>
                                            <div class="col-md-5">
                                                <div class="chart-container">
                                                    <canvas id="unitChart"></canvas>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="accordion-item">
                                <h2 class="accordion-header" id="panelsStayOpen-headingTwo">
                                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#panelsStayOpen-collapseTwo" aria-expanded="false"
                                        aria-controls="panelsStayOpen-collapseTwo">
                                        <h5>Chapter Wise Analysis</h5>
                                        <small>This report shows your performance in each chapter, helping you
                                            understand which
                                            chapters you know well and which need more practice.</small>
                                    </button>
                                </h2>
                                <div id="panelsStayOpen-collapseTwo" class="accordion-collapse collapse"
                                    aria-labelledby="panelsStayOpen-headingTwo">
                                    <div class="accordion-body">
                                        <div class="row">
                                            <div class="col-md-7">
                                                <div class="table-responsive">
                                                    <table class="table table-bordered">
                                                        <thead>
                                                            <tr>
                                                                <th>S.No.</th>
                                                                <th>Chapter</th>
                                                                <th>Marks</th>
                                                                <th>Total Question</th>
                                                                <th>Correct Answer</th>
                                                                <th>Obtained Marks</th>

                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr
                                                                *ngFor="let _obj of ReportData.chapterSummary; let i = index">
                                                                <td>{{ i + 1 }}</td>
                                                                <td>
                                                                    {{_obj.ChapterName}}
                                                                </td>

                                                                <td>{{ _obj.Marks }}</td>
                                                                <td>{{ _obj.NOQ }}</td>
                                                                <td>{{ _obj.Total_CorrectAns }}</td>
                                                                <td>{{ _obj.ObtainedMarks }}</td>
                                                            </tr>
                                                        </tbody>
                                                        <tfoot>
                                                            <th colspan="2" style="text-align: end;">Total</th>
                                                            <th>{{ReportData.chapterSummary| sum:'Marks' }}</th>
                                                            <th>{{ReportData.chapterSummary| sum:'NOQ' }}</th>
                                                            <th>{{ReportData.chapterSummary| sum:'Total_CorrectAns' }}
                                                            </th>
                                                            <th>{{ReportData.chapterSummary| sum:'ObtainedMarks' }}</th>
                                                        </tfoot>

                                                    </table>
                                                </div>
                                            </div>
                                            <div class="col-md-5">
                                                <div class="chart-container">
                                                    <canvas id="chpterChart"></canvas>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="accordion-item">
                                <h2 class="accordion-header" id="panelsStayOpen-headingThree">
                                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#panelsStayOpen-collapseThree" aria-expanded="false"
                                        aria-controls="panelsStayOpen-collapseThree">
                                        <h5>Question wise Analysis</h5>
                                        <small>This report shows how you answered each question, so you can check what
                                            you got right
                                            and where you need more practice.</small>
                                    </button>
                                </h2>
                                <div id="panelsStayOpen-collapseThree" class="accordion-collapse collapse"
                                    aria-labelledby="panelsStayOpen-headingThree">
                                    <div class="accordion-body">
                                        <div class="row">

                                            <div class="table-responsive table-scroll" id="table-scroll">
                                                <table class="table table-bordered text-start main-table "
                                                    id="main-table">
                                                    <thead>
                                                        <tr>
                                                            <th>Q.No</th>
                                                            <th>Question Image</th>
                                                            <th>Chapter Name</th>
                                                            <th>Answer </th>
                                                            <th>Answer Marked</th>
                                                            <th>Marks</th>
                                                            <th>Obtained Marks</th>
                                                            <th>Seconds</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>

                                                        <tr *ngFor="let _obj of ReportData.qpar; let i = index">

                                                            <td>{{_obj.QNo }}</td>

                                                            <td>
                                                                <img [src]="_obj.Quctionimage"
                                                                    style="justify-self:fleex-start">

                                                            </td>
                                                            <td>
                                                                {{_obj.ChapterName}}
                                                            </td>

                                                            <td style="display: flex; align-items: center; gap: 10px;">
                                                                <div>
                                                                    ({{ _obj.Answer }} )
                                                                    {{ _obj.OptionText }}
                                                                </div>

                                                                <img *ngIf="_obj.OptionImage" [src]="_obj.OptionImage"
                                                                    alt="Option Image"
                                                                    style="width: 50px; height: 50px;" />
                                                            </td>



                                                            <td
                                                                [ngStyle]="{'color':_obj.ObtainedMarks>0?'green':'red','font-weight':_obj.ObtainedMarks>0?'bold':''} ">


                                                                <!-- {{ _obj.AnswerMarked }} -->

                                                                <div>
                                                                    {{ _obj.AnswerMarked }} -
                                                                    {{ _obj.AnswerMarkedOptionText }}
                                                                </div>

                                                                <img *ngIf="_obj.AnswerMarkedOptionImage"
                                                                    [src]="_obj.AnswerMarkedOptionImage"
                                                                    alt="Option Image"
                                                                    style="width: 50px; height: 50px;" />

                                                            </td>
                                                            <td>{{ _obj.Marks }}</td>
                                                            <td>{{ _obj.ObtainedMarks>0?_obj.ObtainedMarks:'-' }}</td>
                                                            <td>{{_obj.TimeTaken}}</td>
                                                        </tr>
                                                    </tbody>
                                                    <tfoot>
                                                        <th colspan="5" style="text-align: end;">Total</th>

                                                        <th>{{ReportData.qpar| sum:'Marks'| number:'1.2-2' }}</th>


                                                        <th>{{ReportData.qpar| sum:'ObtainedMarks'| number:'1.2-2' }}
                                                        </th>
                                                        <th>{{(ReportData.qpar| sum:'TimeTaken') * 1000 |
                                                            date:'mm:ss':'UTC' }}</th>
                                                    </tfoot>

                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="accordion-item" *ngIf="ReportData.windowChangeList.length>0">
                                <h2 class="accordion-header" id="panelsStayOpen-headingFour">
                                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#panelsStayOpen-collapseFour" aria-expanded="false"
                                        aria-controls="panelsStayOpen-collapseFour">
                                        <h5> Time spent outside the exam window.</h5>
                                        <small> Represents the cumulative duration, measured in seconds, that the
                                            candidate remained
                                            outside the designated exam window during the assessment.</small>
                                    </button>
                                </h2>
                                <div id="panelsStayOpen-collapseFour" class="accordion-collapse collapse"
                                    aria-labelledby="panelsStayOpen-headingFour">
                                    <div class="accordion-body">
                                        <div class="row">
                                            <div class="table-responsive table-scroll" id="table-scroll">
                                                <table class="table table-bordered text-start main-table "
                                                    id="main-table">
                                                    <thead>
                                                        <tr>
                                                            <th>S.No.</th>
                                                            <th>Out</th>
                                                            <th>In</th>
                                                            <th>Out from Exam Windows (Seconds) </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr
                                                            *ngFor="let _obj of ReportData.windowChangeList; let i = index">

                                                            <td>{{i+1 }}</td>
                                                            <td>{{_obj.OutDate_Time| date:'dd-MMM-yyyy HH:mm:ss a'}}
                                                            </td>
                                                            <td>{{ _obj.InDate_Time| date:'dd-MMM-yyyy HH:mm:ss a' }}
                                                            </td>
                                                            <td>{{_obj.Seconds}}</td>
                                                        </tr>
                                                    </tbody>
                                                    <tfoot>
                                                        <th colspan="3" style="text-align: end;">Total</th>
                                                        <th>
                                                            {{ formatTimeFromSeconds(ReportData.windowChangeList |
                                                            sum:'Seconds') }}
                                                        </th>
                                                    </tfoot>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="accordion-item" *ngIf="ReportData.faceDetectionList.length>0">
                                <h2 class="accordion-header" id="panelsStayOpen-headingFive">
                                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#panelsStayOpen-collapseFive" aria-expanded="false"
                                        aria-controls="panelsStayOpen-collapseFive">
                                        <h5>Live Captured Images</h5>
                                        <small>Images automatically captured in real-time during the examination to
                                            monitor and
                                            verify candidate activity.</small>
                                    </button>
                                </h2>
                                <div id="panelsStayOpen-collapseFive" class="accordion-collapse collapse"
                                    aria-labelledby="panelsStayOpen-headingFive">
                                    <div class="accordion-body">
                                        <div class="row">
                                            <div class="table-responsive table-scroll" id="table-scroll">
                                                <table class="table table-bordered text-start main-table "
                                                    id="main-table">
                                                    <thead>
                                                        <tr>
                                                            <th>S.No.</th>
                                                            <th>Date</th>
                                                            <th>Image</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr
                                                            *ngFor="let _obj of ReportData.faceDetectionList; let i = index">
                                                            <td>{{i+1 }}</td>
                                                            <td>{{_obj.CurrentDatetime| date:'dd-MMM-yyyy HH:mm:ss a'}}
                                                            </td>
                                                            <td><img [src]="_obj.ImagePath" style="width: 200px;"> </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- <div class="accordion-item">
                                <h2 class="accordion-header" id="panelsStayOpen-headingSix">
                                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#panelsStayOpen-collapseSix" aria-expanded="false"
                                        aria-controls="panelsStayOpen-collapseSix">
                                        heading
                                    </button>
                                </h2>
                                <div id="panelsStayOpen-collapseSix" class="accordion-collapse collapse"
                                    aria-labelledby="panelsStayOpen-headingSix">
                                    <div class="accordion-body">
                                        <div class="row">
                                            content
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="accordion-item">
                                <h2 class="accordion-header" id="panelsStayOpen-headingSeven">
                                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#panelsStayOpen-collapseSeven" aria-expanded="false"
                                        aria-controls="panelsStayOpen-collapseSeven">
                                        heading
                                    </button>
                                </h2>
                                <div id="panelsStayOpen-collapseSeven" class="accordion-collapse collapse"
                                    aria-labelledby="panelsStayOpen-headingSeven">
                                    <div class="accordion-body">
                                        <div class="row">
                                            content
                                        </div>
                                    </div>
                                </div>
                            </div> -->






                        </div>


                    </div>

                </div>








                <!-- 
            <div class="row">
                <div class="col-md-12">
                    <div class="report-section">
                        <strong>Unit Wise Analysis</strong><br>
                        <small>This report shows how you did in each unit, so you can see your strengths and where
                            you
                            can improve.</small>
                    </div>
                </div>
                <div class="col-md-7">
                    <div class="table-responsive">
                        <table class="table table-bordered">
                            <thead>
                                <tr>
                                    <th>S.No.</th>
                                    <th>Unit</th>
                                    <th>Marks</th>
                                    <th>Total Question</th>
                                    <th>Correct Answer</th>
                                    <th>Obtained Marks</th>

                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let _obj of ReportData.unitSummary; let i = index">
                                    <td>{{ i + 1 }}</td>
                                    <td>
                                        {{_obj.UnitNo}}: {{ _obj.UnitName }}
                                    </td>

                                    <td>{{ _obj.Marks }}</td>
                                    <td>{{ _obj.NOQ }}</td>
                                    <td>{{ _obj.Total_CorrectAns }}</td>
                                    <td>{{ _obj.ObtainedMarks }}</td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <th colspan="2" style="text-align: end;">Total</th>
                                <th>{{ReportData.unitSummary| sum:'Marks' }}</th>
                                <th>{{ReportData.unitSummary| sum:'NOQ' }}</th>
                                <th>{{ReportData.unitSummary| sum:'Total_CorrectAns' }}</th>
                                <th>{{ReportData.unitSummary| sum:'ObtainedMarks' }}</th>
                            </tfoot>

                        </table>
                    </div>
                </div>
                <div class="col-md-5">
                    <div class="chart-container">
                        <canvas id="unitChart"></canvas>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="report-section">
                        <strong>Chapter Wise Analysis</strong><br>
                        <small>This report shows your performance in each chapter, helping you understand which
                            chapters you know well and which need more practice.</small>
                    </div>
                </div>
                <div class="col-md-7">
                    <div class="table-responsive">
                        <table class="table table-bordered">
                            <thead>
                                <tr>
                                    <th>S.No.</th>
                                    <th>Chapter</th>
                                    <th>Marks</th>
                                    <th>Total Question</th>
                                    <th>Correct Answer</th>
                                    <th>Obtained Marks</th>

                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let _obj of ReportData.chapterSummary; let i = index">
                                    <td>{{ i + 1 }}</td>
                                    <td>
                                        {{_obj.ChapterName}}
                                    </td>

                                    <td>{{ _obj.Marks }}</td>
                                    <td>{{ _obj.NOQ }}</td>
                                    <td>{{ _obj.Total_CorrectAns }}</td>
                                    <td>{{ _obj.ObtainedMarks }}</td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <th colspan="2" style="text-align: end;">Total</th>
                                <th>{{ReportData.chapterSummary| sum:'Marks' }}</th>
                                <th>{{ReportData.chapterSummary| sum:'NOQ' }}</th>
                                <th>{{ReportData.chapterSummary| sum:'Total_CorrectAns' }}</th>
                                <th>{{ReportData.chapterSummary| sum:'ObtainedMarks' }}</th>
                            </tfoot>

                        </table>
                    </div>
                </div>
                <div class="col-md-5">
                    <div class="chart-container">
                        <canvas id="chpterChart"></canvas>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="report-section">
                        <strong>Question wise Analysis</strong><br>
                        <small>This report shows how you answered each question, so you can check what you got right
                            and where you need more practice.</small>
                    </div>
                </div>
                <div class="table-responsive">
                    <table class="table table-bordered">
                        <thead>
                            <tr>
                                <th>Q.No</th>
                                <th>Question Image</th>
                                <th>Chapter Name</th>
                                <th>Answer</th>
                                <th>Answer Marked</th>
                                <th>Marks</th>
                                <th>Obtained Marks</th>
                                <th>Seconds</th>
                            </tr>
                        </thead>
                        <tbody>

                            <tr *ngFor="let _obj of ReportData.qpar; let i = index">

                                <td>{{_obj.QNo }}</td>

                                <td>
                                    <img [src]="_obj.Quctionimage" style="justify-self:fleex-start">

                                </td>
                                <td>
                                    {{_obj.ChapterName}}
                                </td>

                                <td>{{ _obj.Answer }}</td>
                                <td
                                    [ngStyle]="{'color':_obj.ObtainedMarks>0?'green':'red','font-weight':_obj.ObtainedMarks>0?'bold':''}">
                                    {{ _obj.AnswerMarked }}
                                </td>
                                <td>{{ _obj.Marks }}</td>
                                <td>{{ _obj.ObtainedMarks>0?_obj.ObtainedMarks:'-' }}</td>
                                <td>{{_obj.TimeTaken}}</td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <th colspan="5" style="text-align: end;">Total</th>

                            <th>{{ReportData.qpar| sum:'Marks'| number:'1.2-2' }}</th>


                            <th>{{ReportData.qpar| sum:'ObtainedMarks'| number:'1.2-2' }}</th>
                            <th>{{(ReportData.qpar| sum:'TimeTaken') * 1000 | date:'mm:ss':'UTC' }}</th>
                        </tfoot>

                    </table>
                </div>
            </div>
            <div class="row" *ngIf="ReportData.windowChangeList.length>0">
                <div class="col-md-12">
                    <div class="report-section">
                        <strong> Time spent outside the exam window.</strong> <br>
                        <small> Represents the cumulative duration, measured in seconds, that the candidate remained
                            outside the designated exam window during the assessment.</small>
                    </div>
                </div>
                <div class="table-responsive">
                    <table class="table table-bordered">
                        <thead>
                            <tr>
                                <th>S.No.</th>
                                <th>Out</th>
                                <th>In</th>
                                <th>Out from Exam Windows (Seconds) </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let _obj of ReportData.windowChangeList; let i = index">

                                <td>{{i+1 }}</td>
                                <td>{{_obj.OutDate_Time| date:'dd-MMM-yyyy HH:mm:ss a'}}</td>
                                <td>{{ _obj.InDate_Time| date:'dd-MMM-yyyy HH:mm:ss a' }}
                                </td>
                                <td>{{_obj.Seconds}}</td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <th colspan="3" style="text-align: end;">Total</th>
                            <th>
                                {{ formatTimeFromSeconds(ReportData.windowChangeList | sum:'Seconds') }}
                            </th>
                        </tfoot>
                    </table>
                </div>
            </div>
            <div class="row" *ngIf="ReportData.faceDetectionList.length>0">
                <div class="col-md-12">
                    <div class="report-section">
                        <strong>Live Captured Images</strong><br>
                        <small>Images automatically captured in real-time during the examination to monitor and
                            verify candidate activity.</small>
                    </div>
                </div>
                <div class="table-responsive">
                    <table class="table table-bordered">
                        <thead>
                            <tr>
                                <th>S.No.</th>
                                <th>Date</th>
                                <th>Image</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let _obj of ReportData.faceDetectionList; let i = index">
                                <td>{{i+1 }}</td>
                                <td>{{_obj.CurrentDatetime| date:'dd-MMM-yyyy HH:mm:ss a'}}</td>
                                <td><img [src]="_obj.ImagePath" style="width: 200px;"> </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div> -->
                <div class="row">
                    <div class="col-md-12 text-center">
                        <strong>More Reports are coming soon. Please Visit Later…
                        </strong>
                    </div>
                </div>
            </div>


        </div>
    </div>
</div>